export default __webpack_public_path__ + "static/flytteesker-331cf364490c0dd0904f883fc6a46a8c.jpg";